// Fondo decorativo del login: planetas y símbolos de astrología en mosaico,
// con relleno oscuro y transparencia. Puramente visual — sin texto, sin
// datos — por eso no pasa por i18n.
//
// Los íconos son <symbol> reutilizados con <use> dentro de un <pattern> que
// se repite solo (SVG lo tila): ninguna librería externa, ningún asset.

const GLIFOS = ['♈', '♉', '♊', '♋', '♌', '♍', '♎', '♏', '♐', '♑', '♒', '♓', '☉', '☽'];

export function MosaicoAstral({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      aria-hidden="true"
      className={className}
      width="100%"
      height="100%"
      preserveAspectRatio="xMidYMid slice"
    >
      <defs>
        {/* --- Planetas --- */}
        <symbol id="astro-saturno" viewBox="0 0 100 100">
          <ellipse
            cx="50"
            cy="50"
            rx="34"
            ry="10"
            fill="none"
            stroke="currentColor"
            strokeWidth="4"
            transform="rotate(-20 50 50)"
          />
          <circle cx="50" cy="50" r="17" fill="currentColor" />
        </symbol>

        <symbol id="astro-luna-planeta" viewBox="0 0 100 100">
          <circle cx="42" cy="58" r="16" fill="currentColor" />
          <circle cx="76" cy="28" r="7" fill="currentColor" />
        </symbol>

        <symbol id="astro-orbita" viewBox="0 0 100 100">
          <circle cx="50" cy="50" r="13" fill="currentColor" />
          <ellipse
            cx="50"
            cy="50"
            rx="40"
            ry="17"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            transform="rotate(15 50 50)"
          />
        </symbol>

        {/* --- Símbolos astrológicos (glifos) ---
            ︎ fuerza la presentación de texto: sin él, Windows/Chromium
            renderiza estos glifos con la fuente de emoji a color y rompe
            el mosaico monocromo. */}
        {GLIFOS.map((base) => {
          const glifo = `${base}︎`;
          return (
            <symbol key={base} id={`astro-glifo-${base}`} viewBox="0 0 100 100">
              <text
                x="50"
                y="50"
                textAnchor="middle"
                dominantBaseline="central"
                fontSize="72"
                fill="currentColor"
              >
                {glifo}
              </text>
            </symbol>
          );
        })}
      </defs>

      <defs>
        <pattern
          id="astro-mosaico"
          width="420"
          height="420"
          patternUnits="userSpaceOnUse"
          patternTransform="rotate(8)"
        >
          <use href="#astro-glifo-♈" x="10" y="15" width="60" height="60" transform="rotate(-6 40 45)" />
          <use href="#astro-saturno" x="95" y="5" width="78" height="78" transform="rotate(6 134 44)" />
          <use href="#astro-glifo-♍" x="195" y="20" width="56" height="56" transform="rotate(10 223 48)" />
          <use href="#astro-glifo-☽" x="270" y="10" width="52" height="52" transform="rotate(-10 296 36)" />
          <use href="#astro-glifo-♑" x="350" y="20" width="58" height="58" transform="rotate(8 379 49)" />

          <use href="#astro-glifo-♉" x="30" y="110" width="58" height="58" transform="rotate(12 59 139)" />
          <use href="#astro-orbita" x="115" y="100" width="80" height="80" transform="rotate(-8 155 140)" />
          <use
            href="#astro-glifo-♋"
            x="220"
            y="115"
            width="56"
            height="56"
            transform="rotate(-12 248 143)"
          />
          <use href="#astro-glifo-♐" x="300" y="105" width="58" height="58" transform="rotate(9 329 134)" />
          <use href="#astro-glifo-☉" x="365" y="115" width="54" height="54" transform="rotate(-5 392 142)" />

          <use href="#astro-glifo-♊" x="10" y="215" width="56" height="56" transform="rotate(-9 38 243)" />
          <use href="#astro-glifo-♏" x="90" y="225" width="58" height="58" transform="rotate(7 119 254)" />
          <use href="#astro-saturno" x="175" y="215" width="72" height="72" transform="rotate(-14 211 251)" />
          <use href="#astro-glifo-♒" x="270" y="220" width="58" height="58" transform="rotate(11 299 249)" />
          <use href="#astro-glifo-♌" x="355" y="210" width="56" height="56" transform="rotate(-6 383 238)" />

          <use href="#astro-glifo-♓" x="45" y="315" width="60" height="60" transform="rotate(5 75 345)" />
          <use
            href="#astro-luna-planeta"
            x="140"
            y="305"
            width="76"
            height="76"
            transform="rotate(-4 178 343)"
          />
          <use href="#astro-glifo-♎" x="245" y="320" width="56" height="56" transform="rotate(13 273 348)" />
          <use href="#astro-glifo-♑" x="330" y="310" width="58" height="58" transform="rotate(-9 359 339)" />
        </pattern>
      </defs>

      <rect width="100%" height="100%" fill="url(#astro-mosaico)" />
    </svg>
  );
}
